"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackButton = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const S = __importStar(require("./Navbar.style"));
const useBackNavigation_1 = require("../../../hooks/useBackNavigation");
const mapParamsHandler_1 = require("../../../utils/mapParamsHandler");
const useScreenSizeDetection_1 = __importDefault(require("../../../utils/useScreenSizeDetection"));
const userStates_1 = require("../../../types/userStates");
const backArrowIcon_svg_1 = __importDefault(require("../../../assets/icons/backArrowIcon.svg"));
const backArrowIconDesktop_svg_1 = __importDefault(require("../../../assets/icons/backArrowIconDesktop.svg"));
const BackButton = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const handleCalendarGoBack = (0, useBackNavigation_1.useCalendarBackNavigation)();
    const { previousUserSettings } = (0, mapParamsHandler_1.useMapParams)();
    const isMobile = (0, useScreenSizeDetection_1.default)();
    const icon = isMobile ? backArrowIcon_svg_1.default : backArrowIconDesktop_svg_1.default;
    const getButtonText = (0, react_1.useCallback)(() => {
        switch (previousUserSettings) {
            case userStates_1.UserSettings.SessionListView:
                return t("navbar.goBackToSessions");
            case userStates_1.UserSettings.MapView:
                return t("navbar.goBackToMap");
            case userStates_1.UserSettings.ModalView:
                return t("navbar.goBackToSession");
            default:
                return t("navbar.goBackToMap");
        }
    }, [previousUserSettings, t]);
    return (react_1.default.createElement(S.GoBack, { onClick: handleCalendarGoBack, "aria-label": t("navbar.mapPage") },
        react_1.default.createElement("img", { src: icon, alt: t("navbar.altGoBackIcon"), "aria-label": t("navbar.goBackToSessions") }),
        getButtonText()));
};
exports.BackButton = BackButton;
